<template>
  <b-row class="d-flex px-3">
    <b-col class="group group-1 px-0 pr-xl-5">
      <stat-box :label="data.group1.label"
                :value="data.group1.value"
                color="#00D2B4"
                :info="data.group1.info"
                size="large"
                :clickable="data.group1.hasOwnProperty('clickValue')"
                :to="data.group1.to"
      >
        {{ data.group1.value }}<span style="font-size: 50px !important;">%</span>
      </stat-box>
      <div class="divider d-none d-xl-block"></div>
    </b-col>

    <b-col class="group group-2 px-0 pr-xl-5 mt-3">
      <stat-box :label="data.group2.label"
                :value="data.group2.value"
                color="#34668C"
                :clickable="data.group2.hasOwnProperty('clickValue')"
                :to="data.group2.to"
                css-class="pl-xl-3 divider"
      />
    </b-col>

    <div class="d-block d-xl-none w-100"></div>

    <b-col class="group group-3 pr-lg-5 pr-xl-3 mt-3">
        <b-row class="px-xl-5 divider">
          <b-col cols="3" class="px-0">
            <stat-box :label="data.group3.label"
                      :value="data.group3.value"
                      color="#DE4618"
                      :clickable="data.group3.hasOwnProperty('clickValue')"
                      :to="data.group3.to"
            />
          </b-col>
          <b-col cols="9" class="px-0">
            <b-row>
              <b-col cols="3" class="pt-3 px-0" v-for="item in data.group3.subgroups">
                <stat-box :label="item.label"
                          :value="item.value"
                          color="#DE4618"
                          size="small"
                          label-color="#2C3E38"
                          align="center"
                          :clickable="item.hasOwnProperty('clickValue')"
                          :to="item.to"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
    </b-col>

    <div class="d-block d-lg-none w-100"></div>

    <b-col class="group group-4 pl-lg-5 pl-xl-3 mt-3">
      <b-row class="pl-xl-5 divider">
        <b-col cols="3" class="px-0">
          <stat-box :label="data.group4.label"
                    :value="data.group4.value"
                    color="#00D2B4"
                    :clickable="data.group4.hasOwnProperty('clickValue')"
                    :to="data.group4.to"
          />
        </b-col>
        <b-col cols="9" class="px-0">
          <b-row>
            <b-col cols="3" class="pt-3 px-0" v-for="item in data.group4.subgroups">
              <stat-box :label="item.label"
                        :value="item.value"
                        color="#00D2B4"
                        size="small"
                        label-color="#2C3E38"
                        align="center"
                        :clickable="item.hasOwnProperty('clickValue')"
                        :to="item.to"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import StatBox from '@/components/Dashboard/StatBox';

export default {
  name: "StatPanel",
  components: {
    StatBox,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>

  @media screen and (min-width: 1200px) {
    .divider {
      border-left: 1px solid #CCD9E2;
    }

    .group-1 {
      max-width: 190px !important;
    }
    .group-2 {
      max-width: 170px !important;
    }
    .group-3 {
      max-width: 650px !important;
    }
    .group-4 {
      max-width: 650px !important;
    }
  }

  @media screen and (min-width: 1200px) and (max-width: 1399px) {
    .group-3 .divider {
      padding-left: 1rem !important;
      padding-right: 1rem !important;
    }
    .group-4 .divider {
      padding-left: 1rem !important;
    }
    .group-3 .medium .value {
      font-size: 20px;
    }
  }

</style>

<style lang="scss">
  @media screen and (min-width: 1200px) and (max-width: 1699px) {
    .group {
      .large {
        .value {
          font-size: 50px;
        }
      }
      .medium {
        .value {
          font-size: 32px;
        }
      }
      .small {
        .value {
          font-size: 20px;
        }
      }
    }
  }
</style>
